import { colorsPalettes } from "@similarweb/styles";
import { TubeSwitcherItem } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import React from "react";
import { connect } from "react-redux";
import { allTrackers } from "app/services/track/track";
import styled from "styled-components";
import { dashboardWizardWidgetTypeChanged } from "../actions/dashboardWizardActionCreators";
import { StatefullIconSwitcher } from "./StatefullIconSwitcher";

const SwitcherItemStyled: any = styled(TubeSwitcherItem)`
    &.selected {
        &:before {
            color: ${colorsPalettes.blue[500]};
        }
    }
`;

class DashboardWizardTypeSwitcher extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <div className="chartSwitcher">
                    <h4>
                        <I18n>home.dashboards.wizard.preview.title</I18n>
                    </h4>
                    <h5>
                        <I18n>home.dashboards.wizard.visualization.title</I18n>
                    </h5>
                    <StatefullIconSwitcher
                        items={this.props.dashboardWizard.availableWidgetTypes}
                        selected={this.props.dashboardWizard.selectedWidgetType}
                        onItemClicked={(item) => this.props.changeWidgetType(item, this.props.dashboardWizard)}
                        clickedItemProperty={this.clickedItemProperty}
                        clickItemTracking={this.clickItemTracking}
                    />
                </div>
            </div>
        );
    }

    clickedItemProperty = (item) => item;
    clickItemTracking = (item) => {
        allTrackers.trackEvent(
            "Capsule Button",
            "switch",
            `Visualization/${this.props.dashboardWizard.availableWidgetTypes[item].id}`,
        );
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeWidgetType: (newType, customDashboard) => {
            dispatch(dashboardWizardWidgetTypeChanged(customDashboard, newType));
        },
    };
}

function mapStateToProps({ customDashboard: { dashboardWizard } }) {
    return {
        dashboardWizard,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWizardTypeSwitcher);
